module.exports = require("./ks-Arab.js");